import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';
import { DialogService } from './dialog-service';
import { CommonService } from '../../common/services/common.service';
import { DialogConfig } from '../components/dialog/dialog';

/**
 * Interface to enforce the `canDeactivate` method in components.
 */
export interface FormCanDeactivate {
  canDeactivate(): boolean;
}

/**
 * Guard to check if unsaved changes exist before navigating away.
 */
export const CanDeactivateGuard: CanDeactivateFn<FormCanDeactivate> = (component) => {
  const dialogService = inject(DialogService);
  const commonService = inject(CommonService);
  commonService.navLoader.next(false);
  // If the component has unsaved changes, show a confirmation dialog
  if (!component.canDeactivate()) {
    return new Observable<boolean>((observer) => {
      const config: DialogConfig = { message: 'Unsaved changes! Are you sure you want to leave this page?' };
      dialogService.open(config).then(result => {
        if (result) {
          commonService.navLoader.next(result);
          observer.next(true);
          observer.complete();
        } else {
          observer.next(false);
          observer.complete();
        }
      });
    });
  }
  return true;
};
